import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Tag, Button, App } from 'antd';
import { fetchProductDetail } from '../../api';
import { useAuth } from '../../context/AuthContext';
import './ServiceDetail.scss';

function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, addSelectedItem } = useAuth();
  const { message } = App.useApp();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetchProductDetail(id).then((p) => {
      if (!mounted) return;
      setProduct(p);
      setLoading(false);
    });
    return () => {
      mounted = false;
    };
  }, [id]);

  const handleReserve = (item) => {
    if (!user) {
      message.warning('请先登录后再预定');
      return;
    }
    addSelectedItem({
      id: item.id,
      name: item.name,
      spec: item.spec,
      price: item.price,
      icon: item.icon,
      from: product ? product.title : '',
    });
    message.success(`已加入「我的选购」：${item.name}`);
  };

  if (loading) {
    return (
      <div className="service-detail">
        <div className="container">
          <div className="page-loading">加载中...</div>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="service-detail">
        <div className="container">
          <div className="detail-empty">
            <h2>未找到该服务</h2>
            <p>该服务可能已下架或链接有误</p>
            <Link to="/services" className="btn btn-primary">
              返回产品服务
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const isPaid = product.isPaid;
  const hasQRCode = product.hasQRCode;

  // 付费咨询跳转
  const handlePaidConsult = () => {
    if (!user) {
      message.warning('请先登录后再进行付费咨询');
      navigate('/login?redirect=/payment');
      return;
    }
    navigate('/payment');
  };

  return (
    <div className="service-detail">
      <div className="container">
        {/* 面包屑 */}
        <div className="detail-crumb">
          <Link to="/">首页</Link>
          <span>/</span>
          <Link to="/services">产品服务</Link>
          <span>/</span>
          <em>{product.title}</em>
        </div>

        {/* 概览 */}
        <div className="detail-head">
          <div className="detail-icon">{product.icon}</div>
          <div>
            <h1>{product.title}</h1>
            <p>{product.desc}</p>
            <div className="detail-tags">
              {product.features.map((f) => (
                <Tag key={f} color="gold">
                  {f}
                </Tag>
              ))}
            </div>
          </div>
        </div>

        {/* 微信小程序二维码（精品成品家具） */}
        {hasQRCode && (
          <section className="detail-block">
            <h2 className="block-title">微信小程序选购</h2>
            <p className="block-sub">扫描下方二维码，进入好美意微信小程序，在线浏览并购买精品成品家具</p>
            <div className="qrcode-section">
              <div className="qrcode-card">
                <img src="/qrcode-miniprogram.jpg" alt="好美意小程序二维码" className="qrcode-img" />
                <p className="qrcode-tip">微信扫一扫，进入小程序</p>
              </div>
            </div>
          </section>
        )}

        {/* 可购买 / 预定的家居清单 */}
        {product.items && product.items.length > 0 && (
          <section className="detail-block">
            <h2 className="block-title">可供购买 / 预定的家居</h2>
            <p className="block-sub">点击「预定」即可加入您的账号选购清单</p>
            <div className="furniture-grid">
              {product.items.map((item) => (
                <div className="furniture-card" key={item.id}>
                  <div className="furniture-icon">{item.icon}</div>
                  <h3>{item.name}</h3>
                  <p className="furniture-spec">{item.spec}</p>
                  <div className="furniture-bottom">
                    <span className="furniture-price">¥{item.price}</span>
                    <Button type="primary" onClick={() => handleReserve(item)}>
                      预定
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* 咨询类服务 CTA */}
        {(!product.items || product.items.length === 0) && !hasQRCode && (
          <section className="detail-block">
            <div className={`detail-cta ${isPaid ? 'detail-cta-paid' : ''}`}>
              <h2>{isPaid ? '付费勘察咨询' : '预约专属顾问'}</h2>
              <p>
                {isPaid
                  ? '专业工程师上门对房屋装修现场进行全面勘验，出具详细勘察报告，为您的装修决策提供专业依据。'
                  : '该服务为定制 / 咨询类，点击预约后顾问将与您联系，免费量房设计。'}
              </p>
              <Button
                type="primary"
                size="large"
                onClick={isPaid ? handlePaidConsult : () => navigate('/contact')}
              >
                {isPaid ? '立即付费咨询' : '立即预约咨询'}
              </Button>
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default ServiceDetail;
